import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class ProjectUserLookUpModel extends ModelBase<ProjectUserLookUpModel, any> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = ProjectUserLookUpModel.DEFAULT_ID;

    @observable
    public displayName: string = ProjectUserLookUpModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = ProjectUserLookUpModel.DEFAULT_ID;
        this.displayName = ProjectUserLookUpModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: ProjectUserLookUpModelDTO): void {
        this.id = dto.id;
        this.displayName = `${dto.lastName}, ${dto.firstName}`;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: ProjectUserLookUpModelDTO[]): ProjectUserLookUpModel[] {
        const types: ProjectUserLookUpModel[] = [];

        for (const dto of dtos) {
            const model = new ProjectUserLookUpModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface ProjectUserLookUpModelDTO {
    id: string;
    firstName: string;
    lastName: string;
}
